
import Login from '~/mixins/pages/login/login'
export default {
    name: 'Theme3LoginModal',
    mixins: [Login],
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showLoginForm: true,
        }
    },
    computed: {
        modal: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    methods: {
        onCloseModal() {
            this.modal = false
            this.$emit('onCloseModal')
        },
    },
}
